import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ListEmployeesImages from '../../list-employees-images';
import AppHeader from '../../header';
import AppLayoutComponent from '../common';
export default function ListEmployeesImagesPageContent() {
    return (_jsx(AppLayoutComponent, { forceToolsClosed: true, content: _jsxs(_Fragment, { children: [_jsx(AppHeader, { title: "Images" }, void 0),
                _jsx(ListEmployeesImages, {}, void 0)] }, void 0) }, void 0));
}
